import React from "react";
import { cn } from "@/lib/utils";

const Eyebrow = ({ className, children }: { className?: string; children: React.ReactNode }) => {
  return (
    <p className={cn("text-[13px] font-semibold tracking-[0.12em] text-brand-ink-strong uppercase", className)}>
      {children}
    </p>
  );
};

export default Eyebrow;
